/**
 * DevExtreme (ui/scheduler/constants.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var LIST_ITEM_DATA_KEY = exports.LIST_ITEM_DATA_KEY = "dxListItemData";
var FIXED_CONTAINER_CLASS = exports.FIXED_CONTAINER_CLASS = "dx-scheduler-fixed-appointments";
var LIST_ITEM_CLASS = exports.LIST_ITEM_CLASS = "dx-list-item";
var REDUCED_APPOINTMENT_CLASS = exports.REDUCED_APPOINTMENT_CLASS = "dx-scheduler-appointment-reduced";
var COMPACT_APPOINTMENT_CLASS = exports.COMPACT_APPOINTMENT_CLASS = "dx-scheduler-appointment-compact";
var RECURRENCE_APPOINTMENT_CLASS = exports.RECURRENCE_APPOINTMENT_CLASS = "dx-scheduler-appointment-recurrence";



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/scheduler/constants.js
// module id = 273
// module chunks = 0